import { EKioskRouterNames, ERouterNames } from '@/types';
import { LOCAL_STORAGE_KEYS } from './constants';
import { checkIsKiosk } from './kiosk';
/**
 * Returns the appropriate login route based on the current context and last login method.
 *
 * Priority:
 * 1. If currently in kiosk mode (URL starts with `/kiosk`), returns `EKioskRouterNames.KIOSK`.
 * 2. If the last login method was via device (stored in `localStorage`), returns `ERouterNames.LOGIN_DEVICE`.
 * 3. Otherwise, returns the default `ERouterNames.LOGIN`.
 * @returns The route name for login or kiosk redirection.
 */
export const getLinkToLogin = (): ERouterNames | EKioskRouterNames => {
  const loginBy = localStorage.getItem(LOCAL_STORAGE_KEYS.LOGIN_SOURCE);
  const isKiosk = checkIsKiosk();
  if (isKiosk) return EKioskRouterNames.KIOSK;
  if (loginBy === 'device') return ERouterNames.LOGIN_DEVICE;
  return ERouterNames.LOGIN;
};
